/**
 * Created by roi on 15/03/17.
 */
import { createSelector } from 'reselect';

import { buscarPeriode } from '../components/commons/periodes';

const observacionsSelector = (state) => {
    if (!state.observacio.totes) {
        return null;
    }
    return state.observacio.totes.observacions;
};
const filtrePeriodeSeleccionatSelector = state => state.observacio.periodeSeleccionat;

/**
 * Donat un array d'observacions es realitza una cerca per tal de trobar les observacions que tenen una o varies
 * variables pel periode especificat per paràmetre. En càs que el periode especificat sigui diferent de '7h', '13h' o '18h',
 * s'gafaran les observacions amb lectures pel periode de mati.
 *
 * El resultat es una llista d'observacions que tenen informada alguna variable pel periode especificat.
 *
 *  En cas de no especificar un dels dos paramtres o que aquets estiguin vuits es retorna un array vuit.
 * @param observacions {Array}
 * @param filtrePeriode {String}
 * @returns {Array}
 */
const obtenirObservacionsFiltradesPerPeriode = (observacions, filtrePeriode) => {
    let observacionsFiltrades = [];

    if (!observacions || !filtrePeriode) {
        return observacionsFiltrades;
    }

    observacions.forEach((observacio) => {
        let trobadaObservacioPerPeriode;

        trobadaObservacioPerPeriode = observacio.grupsVariables.some((grupVariable) => {
            return grupVariable.variables.some((variable) => {
                return variable.moments.some((moment) => {

                    const nomPeriode = buscarPeriode(moment.nom);
                    return (nomPeriode === filtrePeriode);
                });
            });
        });

        if (trobadaObservacioPerPeriode) {
            observacionsFiltrades.push(observacio);
        }
    });

    return observacionsFiltrades;
};

const selector = createSelector(
    observacionsSelector,                   //Totes les observacions
    filtrePeriodeSeleccionatSelector,       //Filtre, que conté el periode pel qual es vol filtrar

    obtenirObservacionsFiltradesPerPeriode  //Aquesta és la que s'executa
);
export default selector;



// WEBPACK FOOTER //
// ./src/selectors/selector_periode_observacio.js